var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.17804 19.3375L10.6795 1.78336C10.809 1.54627 11 1.34841 11.2323 1.21058C11.4647 1.07274 11.7298 1 12 1C12.2702 1 12.5353 1.07274 12.7677 1.21058C13 1.34841 13.191 1.54627 13.3205 1.78336L22.822 19.3375C22.9445 19.5654 23.0057 19.8213 22.9996 20.0799C22.9935 20.3386 22.9203 20.5913 22.7872 20.8132C22.654 21.035 22.4655 21.2185 22.2402 21.3456C22.0148 21.4728 21.7603 21.5391 21.5015 21.5383H2.49997C2.24109 21.5394 1.98638 21.4732 1.7608 21.3462C1.53522 21.2192 1.34653 21.0357 1.21322 20.8138C1.07992 20.5919 1.00659 20.3391 1.00042 20.0803C0.994255 19.8215 1.05546 19.5655 1.17804 19.3375V19.3375Z",
    stroke: "#EC2B00",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6.86646V14.2024",
    stroke: "#EC2B00",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 18.6041C12.6078 18.6041 13.1004 18.1114 13.1004 17.5037C13.1004 16.896 12.6078 16.4033 12 16.4033C11.3923 16.4033 10.8997 16.896 10.8997 17.5037C10.8997 18.1114 11.3923 18.6041 12 18.6041Z",
    fill: "#EC2B00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.5b805b131ade7f29941f3850f7fc8695.svg";
export { ForwardRef as ReactComponent };